import {
  Component,
  computed,
  input,
  Input,
  OnChanges,
  SimpleChanges,
  output,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Steps } from 'primeng/steps';
import { NgClass } from '@angular/common';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-progress-stepper',
  templateUrl: './m-progress-stepper.component.html',
  styleUrl: './m-progress-stepper.component.scss',
  imports: [NgClass, Steps]
})
export class MProgressStepperComponent implements OnChanges {
  @ViewChild('list', { static: false }) list!: Steps;
  @Input() steps: MenuItem[] = [];
  @Input() activeStep = 0;
  @Input() styleClass = '';
  @Input() readonly = true;
  alignText = input<'center' | 'left'>('center');
  textPosition = input<'top' | 'bottom'>('top');
  readonly activeStepChange = output<number>();

  computedStyleClass = computed(() => {
    return `${this.#alignTextClass()} ${this.#textPositionClass()}`;
  });

  #alignTextClass = computed(() => {
    return this.alignText() === 'left'
      ? 'm-stepper-text-left'
      : 'm-stepper-text-center';
  });

  #textPositionClass = computed(() => {
    return this.textPosition() === 'bottom'
      ? 'm-stepper-position-bottom'
      : 'm-stepper-position-top';
  });

  onActiveIndexChange(event: number) {
    this.activeStepChange.emit(event);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes?.['activeStep']?.['currentValue'] !==
      changes?.['activeStep']?.previousValue
    ) {
      this.activeStep = changes?.['activeStep']?.currentValue;
      this.setActiveClassForSteps();
    }
  }

  private setActiveClassForSteps(): void {
    if (this.steps?.length) {
      this.steps.forEach((step, index) => {
        if (this.activeStep >= 0 && index <= this.activeStep) {
          step.styleClass = 'active';
        } else {
          delete step.styleClass;
        }
      });
    }
  }
}
